import React from 'react';
import PlaceholderPage from '../../components/PlaceholderPage';

const Lockers = () => <PlaceholderPage title="락커 관리" description="락커 배정과 이용 기간을 관리해요." />;

export default Lockers;
